"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormControlPrivate } from "./FormControl.context.js";
import Text from "../Text/index.js";
import s from "./FormControl.module.css";
const FormControlLabel = (props) => {
    const { children } = props;
    const { attributes, required, group, disabled, size } = useFormControlPrivate();
    const id = `${attributes.id}-label`;
    const TagName = group ? "legend" : "label";
    return (_jsxs(Text, { variant: size === "large" ? "body-2" : "body-3", weight: "medium", className: s.label, color: disabled ? "disabled" : undefined, "aria-disabled": disabled, children: [_jsx(TagName, { id: id, htmlFor: group ? undefined : attributes.id, children: children }), required && (_jsx(Text, { color: disabled ? "disabled" : "critical", as: "span", children: "*" }))] }));
};
FormControlLabel.displayName = "FormControl.Label";
export default FormControlLabel;
